/* unplugin-vue-components disabled */import script from "./blknews.vue?vue&type=script&setup=true&lang=js"
export * from "./blknews.vue?vue&type=script&setup=true&lang=js"

import "./blknews.vue?vue&type=style&index=0&id=111a5d6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-111a5d6c"]])

export default __exports__